import { DAY_RANGE, MONTH_RANGE } from 'module/Modals/Staff/constants'

export const getReportDatesOptions = () => ([
  MONTH_RANGE,
  DAY_RANGE,
])
